import type { StatsPanelData, StatsRow } from "./viewModels/statsViewModel";

export function createStatsPanel(data: StatsPanelData): HTMLElement {
	const container = document.createElement("div");
	container.className = "stats-panel";

	if (data.headerLine) {
		const header = document.createElement("div");
		header.className = "stats-header";
		header.textContent = data.headerLine;
		container.appendChild(header);
	}

	// Section order is implicit — driven by first-seen order from the view model.
	const sectionOrder: string[] = [];
	const sectionRows = new Map<string, StatsRow[]>();
	for (const row of data.rows) {
		const section = row.section ?? "";
		if (!sectionRows.has(section)) {
			sectionOrder.push(section);
			sectionRows.set(section, []);
		}
		sectionRows.get(section)!.push(row);
	}

	for (const sectionName of sectionOrder) {
		const rows = sectionRows.get(sectionName) ?? [];
		if (rows.length === 0) continue;

		const sectionEl = document.createElement("div");
		sectionEl.className = "stats-section";

		if (sectionName) {
			const header = document.createElement("div");
			header.className = "stats-section-header";
			header.textContent = sectionName;
			sectionEl.appendChild(header);
		}

		const body = document.createElement("div");
		body.className = "stats-section-body";
		for (const row of rows) {
			body.appendChild(renderRow(row));
		}
		sectionEl.appendChild(body);
		container.appendChild(sectionEl);
	}

	if (container.children.length === 0) {
		const empty = document.createElement("div");
		empty.className = "stats-empty";
		empty.textContent = "\u2014";
		container.appendChild(empty);
	}

	return container;
}

function renderRow(row: StatsRow): HTMLElement {
	const line = document.createElement("div");
	line.className = row.isSubEntry ? "stats-row sub" : "stats-row";

	const lbl = document.createElement("span");
	lbl.className = "stats-label";
	lbl.textContent = row.label;

	const val = document.createElement("span");
	// Sub-entries keep the dimmed .stats-row.sub colour.
	if (!row.isSubEntry) val.className = "stats-value";
	val.textContent = row.value;

	line.appendChild(lbl);
	line.appendChild(val);
	return line;
}
